import React, { useEffect } from 'react';
import { Boxed } from '../../../components/Boxed.components';
import { Loader } from '../../../components/Loader.components';
import { Theme } from '../../../utils/theme';
import { Avatar } from '../../../components/Avatar.components';
import { formatDateTime } from '../../../utils/utils';

export const Activities = (props) => {
  // state props
  const { applicationData, profile, isLoading, activitiesList } = props;

  // dispatch props
  const { fetchActivities } = props;

  useEffect(() => {
    if (applicationData?._id) {
      fetchActivities(applicationData?._id);
    }
  }, [applicationData?._id]);

  const ActivityCard = ({ item }) => {
    const { value, createdAt, actor } = item;
    return (
      <Boxed pad="10px" background={Theme.TertiaryDark} borderRadius={Theme.PrimaryRadius}>
        <Boxed>
          <Avatar
            name={`${item.action}`}
            info={`By ${actor?.lastName} ${actor?.firstName} - ${
              createdAt && formatDateTime(createdAt)
            }`}
            src={actor?.profilePictureUrl}
          />
        </Boxed>
      </Boxed>
    );
  };

  return (
    <Boxed pad="20px 0">
      {isLoading ? (
        <Boxed display="flex">
          <Loader margin="auto" />
        </Boxed>
      ) : (
        <Boxed pad="0 0 15px 0">
          {activitiesList?.map((item, index) => {
            return (
              <Boxed pad="5px 0" key={index}>
                <ActivityCard item={item} />
              </Boxed>
            );
          })}
        </Boxed>
      )}
    </Boxed>
  );
};
